import _ from "lodash/fp";

const clearState = (key) => {
  console.debug(`Clearing ${key} state`);
  try {
    sessionStorage.clear(key);
  } catch (e) {
    console.error(`Could not clear ${key} state: %o`, e);
  }
};

const clearWorkspaceState = (path) => {
  path && console.debug(`Clearing workspace state at ${path}`);
  try {
    path
      ? setState("workspace")(_.unset(path)(getWorkspaceState()))
      : removeState("workspace");
  } catch (e) {
    console.error(`Could not clear workspace state at ${path}: %o`, e);
  }
};

const getState = (key) => {
  console.debug(`Getting ${key} state`);
  try {
    const state = sessionStorage.getItem(key);
    return state === "undefined" ? undefined : JSON.parse(state);
  } catch (e) {
    console.error(`Could not get ${key} state: %o`, e);
  }
};

const getWorkspaceState = (path) => {
  path && console.debug(`Getting workspace state at ${path}`);
  try {
    const workspaceState = getState("workspace") || {};
    return path ? _.get(path)(workspaceState) : workspaceState;
  } catch (e) {
    console.error(`Could not get workspace state at ${path}: %o`, e);
  }
};

const removeState = (key) => {
  console.debug(`Removing ${key} state`);
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    console.error(`Could not remove ${key} state: %o`, e);
  }
};

const setState = (key) => (value) => {
  console.debug(`Setting ${key} state to %o`, value);
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error(`Could not set ${key} state to %o: %o`, value, e);
  }
};

const setWorkspaceState = (path) => (value) => {
  console.debug(`Setting workspace state at ${path} to %o`, value);
  try {
    setState("workspace")(_.set(path)(value)(getWorkspaceState()));
  } catch (e) {
    console.error(
      `Could not set workspace state at ${path} to %o: %o`,
      value,
      e
    );
  }
};

export {
  clearState,
  clearWorkspaceState,
  getState,
  getWorkspaceState,
  removeState,
  setState,
  setWorkspaceState,
};
